import React from "react";

const blogs = [
  {
    img: "/images/keyword/1.jpg",
    title: "Corporate cab service in pune",
    description:
      "Experience seamless mobility with our Corporate Cab Service in Pune. Professional, reliable, and cost-effective travel solutions designed for both daily office commutes and business assignments.",
    link: "corporate-cab-service-in-pune",
  },
  {
    img: "/images/keyword/120.jpg",
    title: "Monthly Cab Services in Pune",
    description:
      "Enjoy stress-free commuting with our Monthly Cab Services in Pune. Affordable, timely, and comfortable travel options perfect for regular office travel and long-term corporate needs.",
    link: "Monthly-Cab-Services-in-Pune",
  },
  {
    img: "/images/keyword/61.jpg",
    title: "Corporate Cab Services in Bangalore",
    description:
      "Experience smooth and reliable travel with our Corporate Cab Services in Bangalore. Cost-effective, punctual, and comfortable solutions ideal for daily employee commutes and business travel needs.",
    link: "Corporate-Cab-Services-in-Bangalore",
  },

{
  img: "/images/keyword/56.jpg",
  title: "Corporate Cab Services in Delhi",
  description:
    "Experience seamless and reliable employee transportation with our Corporate Cab Services in Delhi. Pune Corporate Cars India Private Limited offers punctual, comfortable, and cost-effective travel solutions tailored for daily office commutes and corporate travel needs.",
  link: "Corporate-Cab-Services-in-Delhi",
},

{
  img: "/images/keyword/67.jpg",
  title: "Corporate Cab Services in Chennai",
  description:
    "Ensure smooth and stress-free corporate travel with our Corporate Cab Services in Chennai. Pune Corporate Cars India Private Limited provides safe, timely, and affordable cab solutions designed for regular employee transportation and business requirements.",
  link: "Corporate-Cab-Services-in-Chennai",
},

{
  img: "/images/keyword/57.jpg",
  title: "Corporate Cab Service in Gurgaon",
  description:
    "Enjoy dependable and efficient corporate commuting with our Corporate Cab Service in Gurgaon. Pune Corporate Cars India Private Limited delivers professional, comfortable, and economical cab services ideal for office staff and corporate travel operations.",
  link: "Corporate-Cab-Service-in-Gurgaon",
},


];

const Blogs = () => {
  return (
    <>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Blogs</h1>
          </div>
        </div>
      </section>

      <section className="blog-section">
        <div className="container">
          <div className="row">
            {blogs.map((blog, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4">
                <div className="blog-card">
                  <div className="blog-img-box">
                    <img src={blog.img} alt={blog.title} className="blog-img" />
                  </div>
                  <div className="blog-content">
                    <span className="badge">
                      Pune Corporate Cars India Private Limited
                    </span>
                    <h4>{blog.title}</h4>
                    <p>{blog.description}</p>
                    <a href={blog.link} className="read-more">
                      Read More →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blogs;
